const palette = {
  purpleNavy: '#3F4C7D',
  paradisePink: '#EE4266',
  diamond: '#BCF4F5',
  registrationBlack: '#000000',
  wildBlueYonder: '#9AADBF',
};

export default palette;
